module.exports = __webpack_public_path__ + "static/media/loadElement.48af2ef6.gif";